import { Link } from "react-router-dom";
import { useFavorites } from "@/hooks/useFavorites";

export interface MovieCardData {
  id: string;
  title: string;
  year: number;
  director: string;
  genre: string;
  cover: string;
  rating: number;
}

interface MovieCardProps {
  movie: MovieCardData;
  showFavorite?: boolean;
}

export default function MovieCard({ movie, showFavorite = true }: MovieCardProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const favorited = isFavorite(movie.id);

  return (
    <Link
      to={`/detail/${movie.id}`}
      data-product-shop
      className="group block bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 电影封面`}
          title={`${movie.title} - 经典电影介绍`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-md bg-background-50/90 text-xs font-medium text-foreground-800">
          {movie.year}
        </span>
        {showFavorite && (
          <button
            type="button"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              toggleFavorite(movie.id);
            }}
            className={`absolute top-2.5 right-2.5 w-8 h-8 rounded-full flex items-center justify-center transition-colors cursor-pointer ${
              favorited
                ? "bg-primary-500 text-background-50"
                : "bg-background-50/90 text-foreground-600 hover:text-primary-600"
            }`}
            aria-label={favorited ? "取消收藏" : "收藏"}
          >
            <i className={favorited ? "ri-heart-fill text-sm" : "ri-heart-line text-sm"}></i>
          </button>
        )}
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 line-clamp-1">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
          导演 · {movie.director}
        </p>
        <div className="mt-2.5 flex items-center justify-between">
          <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs">
            {movie.genre}
          </span>
          <span className="flex items-center gap-1 text-xs text-accent-600 font-medium">
            <i className="ri-star-fill text-xs"></i>
            {movie.rating.toFixed(1)}
          </span>
        </div>
      </div>
    </Link>
  );
}